<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-classevaluate__evaluate-ranked">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getPage()">
                <el-form-item prop="id">
                    <el-select v-model="dataForm.classId" placeholder="请选择班级" clearable filterable>
                        <el-option v-for="classManager in classList" :label="classManager.className"
                                   :value="classManager.id" :key="classManager.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="rollCallDate"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getPage()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportExcel2()">{{ $t('export') }}</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    v-loading="dataListLoading"
                    :data="dataList"
                    border
                    @selection-change="dataListSelectionChangeHandle"
                    style="width: 100%"
                    :default-sort = "{prop: '总分', order: 'null'}"
            >
                <el-table-column
                        prop="setNum"
                        label="座号"
                        header-align="center"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="studentName"
                        label="学生名称"
                        header-align="center"
                        align="center"
                >
                </el-table-column>
                <!--   <el-table-column prop="ranked" label="名次" header-align="center" align="center"></el-table-column>-->
                <el-table-column
                        :prop="item"
                        v-for="(item, index) in typeList"
                        :key="index"
                        :label="item+'（次数）'"
                        header-align="center"
                        align="center"
                >
                    <el-table-column
                            v-for="(t, i) in itemList[item]"
                            :key="i"
                            :label="t"
                            header-align="center"
                            align="center"
                    >
                        <el-table-column
                                :prop="t+'add'"
                                label="加分项"
                                header-align="center"
                                align="center"
                        >
                            <template slot-scope="scope">
                                {{ scope.row[t+'add'] }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                :prop="t+'reduce'"
                                label="减分项"
                                header-align="center"
                                align="center"
                        >
                            <template slot-scope="scope">
                                {{ scope.row[t+'reduce'] }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <!--                        :prop="scoreList[item]"-->
                    <el-table-column
                            label="得分情況"
                            header-align="center"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{ scope.row[item+'total'] }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                        prop="totalScore"
                        label="总分"
                        header-align="center"
                        align="center"
                        sortable
                >
                    <el-table-column
                            prop="totalAddNumber"
                            label="总加分"
                            header-align="center"
                            align="center"
                            sortable
                    ></el-table-column>
                    <el-table-column
                            prop="totalCutNumber"
                            label="总减分"
                            header-align="center"
                            align="center"
                            sortable
                    ></el-table-column>
                </el-table-column>
               <!-- <el-table-column prop="addSore" label="是否获“五星班级”" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column
                        prop="className"
                        label="班级名称"
                        header-align="center"
                        align="center"
                >
                </el-table-column>-->
            </el-table>
            <week-evaluate-profile v-if="weekEvaluateProfileVisible" ref="weekEvaluateProfile"></week-evaluate-profile>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { gradeList } from '@/constant'
import Blob from '../../../vendor/Blob'
import Export2Excel from '../../../vendor/Export2Excel'
import Template from '../devtools/template'
import WeekEvaluateProfile from './week-evaluate-profile.vue'

export default {
  components: { WeekEvaluateProfile, Template },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/classEvaluate/evaluateScore/studentReport',
        getDataListIsPage: false,
        exportURL: '/classEvaluate/evaluateScore/export'
      },
      typeList: [],
      itemList: [],
      rollCallDate: [],
      gradeList,
      scoreList: [],
      classList: [],
      dataForm: {
        startTime: '',
        endTime: '',
        gradeKey: '',
        classId: ''
      },
      weekEvaluateProfileVisible: false
    }
  },
  watch: {},
  mounted () {
    this.init()
    this.getClassList()
  },
  methods: {
    getPage () {
      const date = new Date(this.rollCallDate[0])
      this.dataForm.startTime =
          date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          date.getDate() +
          ' ' +
          '00:00:00'
      const date2 = new Date(this.rollCallDate[1])
      this.dataForm.endTime =
          date2.getFullYear() +
          '-' +
          (date2.getMonth() + 1) +
          '-' +
          date2.getDate() +
          ' ' +
          '23:59:59'
      this.init()
    },
    async init () {
      try {
        const dataList = await this.getDateList() // 获取数据列表
        console.log('数据列表', dataList)
        const typeList = await this.getTypeList()
        console.log('类型列表', typeList)
        const itemList = await this.getItemList()
        console.log('检查项列表', itemList)
        dataList.forEach((data, dataIndex) => {
          typeList.forEach((type, typeIndex) => {
            data[type + 'total'] = 0
            itemList[type].forEach((item, itemIndex) => {
              data[type + 'total'] += data[item + 'reduce']
              data[type + 'total'] += data[item + 'add']
            })
          })
        })
        this.dataList = dataList
      } catch (err) {
        return this.$message.error(err.msg)
      }
    },
    getDateList () {
      return new Promise((resolve, reject) => {
        if (this.rollCallDate.length <= 1) {
          this.dataForm.startTime = ''
          this.dataForm.endTime = ''
        } else {
          const date = new Date(this.rollCallDate[0])
          this.dataForm.startTime =
              date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              '00:00:00'
          const date2 = new Date(this.rollCallDate[1])
          this.dataForm.endTime =
              date2.getFullYear() +
              '-' +
              (date2.getMonth() + 1) +
              '-' +
              date2.getDate() +
              ' ' +
              '23:59:59'
        }

        this.$http
          .get(
              `/classEvaluate/evaluateScore/studentReport?order=&orderField=&startTime=${this.dataForm.startTime}&endTime=${this.dataForm.endTime}&classId=${this.dataForm.classId}&_t=${new Date().getTime()}`
          )
          .then(({ data }) => {
            console.log(data)
            if (data.code !== 0) {
              reject({
                msg: '数据列表获取失败',
                data
              })
              return
            }
            const list = data.data
            resolve(list)
          })
          .catch((err) => {
            reject({
              msg: '数据列表获取失败',
              data: err
            })
          })
      })
    },
    getTypeList () {
      return new Promise((resolve, reject) => {
        this.$http
          .get('classEvaluate/examineType/getNameList')
          .then(({ data: res }) => {
            if (res.code !== 0) {
              reject({
                msg: res.msg,
                data: res
              })
              return
            }
            this.typeList = res.data
            resolve(res.data)
          })
          .catch((err) => {
            reject({
              msg: '获取类型列表失败',
              data: err
            })
          })
      })
    },
    getItemList () {
      return new Promise((resolve, reject) => {
        this.$http
          .get('classEvaluate/examineType/getTypeList')
          .then(({ data: res }) => {
            if (res.code !== 0) {
              reject({
                msg: res.msg,
                data: data
              })
              return
            }
            this.itemList = res.data
            resolve(res.data)
          })
          .catch((err) => {
            reject({
              msg: '获取检查项列表失败',
              data: err
            })
          })
      })
    },
    getClassList () {
      this.$http.get('/classmanage/classmanage/getList/').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      }).catch(() => {
      })
    },
    exportExcel () {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../vendor/Export2Excel') // 此处把路径要写对
        const tHeader = ['班级名称', '名次', '总分']
        // 上面设置Excel的表格第一行的标题
        const filterVal = ['className', 'ranked', 'totalSore']
        console.log(this.typeList)
        this.typeList.forEach((s) => {
          tHeader.push(s)
          filterVal.push(s)
        })
        const list = this.dataList // 把data里的tableData存到list
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '年级统计报表') // "列表excel"  是下载后的表名 可修改
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map((v) => {
        return filterVal.map((j) => v[j])
      })
    },
    exportExcel2 () {
      // 写在需要执行的方法下面
      import('../../../vendor/Export2Excel').then((excel) => {
        const schoolName = this.dataList[0].schoolName
        // const schoolName = '霞浦第三小学'
        const multiHeader2 = [
          schoolName + '“五星班级”周评比栏'
        ] // 导出的表头名
        // 三行
        const header = [
          '座号',
          '姓名'
        ]
        // 二行
        const multiHeader = [
          '座号',
          '姓名'
        ] // 导出的表头名
        const filterVal = [
          'className'
        ]
        // 四行
        const header1 = [
          '座号',
          '姓名'
        ]// 导出的表头字段名
        const ABC = ['C2', 'D2', 'E2', 'F2', 'G2', 'H2', 'I2', 'J2', 'K2', 'L2', 'M2', 'N2', 'O2', 'P2', 'Q2', 'R2', 'S2', 'T2', 'U2', 'V2', 'W2', 'X2', 'Y2', 'Z2', 'AA2', 'AB2', 'AC2', 'AD2', 'AE2', 'AF2', 'AG2', 'AH2']
        const ABCD = ['C3', 'D3', 'E3', 'F3', 'G3', 'H3', 'I3', 'J3', 'K3', 'L3', 'M3', 'N3', 'O3', 'P3', 'Q3', 'R3', 'S3', 'T3', 'U3', 'V3', 'W3', 'X3', 'Y3', 'Z3', 'AA3', 'AB3', 'AC3', 'AD3', 'AE3', 'AF3', 'AG3', 'AH3']
        const merges = [
          'A2:A5'
        ]
        merges.push('B2' + ':' + 'B5')
        // 根据Excel确定要合并的单元格
        // 定义一个数字
        let length = 0
        this.typeList.forEach(type => {
          multiHeader.push(type)
          const length1 = this.itemList[type].length
          console.log(length1)
          merges.push(ABC[length] + ':' + ABC[length + length1 + 1])
          length += length1 + 1
          let length2 = 0
          this.itemList[type].forEach(item => {
            multiHeader.push('')
            header.push(item)
            merges.push(ABCD[length2] + ':' + ABCD[length2 + 2])
            length2 += length2 + 2
            header1.push('加分情况')
            header1.push('减分情况')
            filterVal.push(item)
          })
          header.push('得分情況')
          filterVal.push(type + 'total')
        })
        merges.push(ABC[length] + ':' + ABC[length].substring(0, 1) + '4')
        merges.push(ABC[length + 1] + ':' + ABC[length + 1].substring(0, 1) + '4')
        merges.push(ABC[length + 2] + ':' + ABC[length + 2].substring(0, 1) + '4')
        merges.push('A1' + ':' + ABC[length + 2].substring(0, 1) + '1')
        console.log(merges)
        // multiHeader.push('第  月')
        multiHeader.push('总分')
        filterVal.push('totalScore')
        multiHeader.push('是否获“五星班级”')
        filterVal.push('')
        filterVal.push('className')
        const list = this.dataList // 把data里的tableData存到list
        const data = this.formatJson(filterVal, list)
        const filterName = schoolName + '学“五星班级”月评比栏'
        excel.export_json_to_excel2({
          multiHeader, // 这里是第二行的表头
          multiHeader2, // 这里是第一行的表头
          header, // 这里应该是算第三行的表头
          header1, // 这里应该是算第四行的表头
          data,
          merges,
          filename: filterName
        })
      })
    }/*,
    weekEvaluateProfileConfig () {
      this.weekEvaluateProfileVisible = true
      this.$nextTick(() => {
        console.log(this.dataForm)
        /!* this.$refs.weekEvaluateProfile.dataForm.startTime = this.dataForm.startTime
        this.$refs.weekEvaluateProfile.dataForm.endTime = this.dataForm.endTime
        this.$refs.weekEvaluateProfile.rollCallDate = this.rollCallDate *!/
        this.$refs.weekEvaluateProfile.init()
      })
    } */
  }
}
</script>
